import Prayer from "./Prayer";
import { BsArrowUp } from "react-icons/bs"

function Ending() {

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" })
    }

    return (
        <>
            <Prayer prayer="hailHolyQueen" />
            <Prayer prayer="rosaryPrayer" />
            <Prayer prayer="signOfTheCrossSecond" />
            <button className="primary back-to-top" onClick={scrollToTop}>
                <BsArrowUp /> ZPĚT NAHORU <BsArrowUp />
            </button>
        </>
    );
}

export default Ending;